import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

const LikesContext = createContext();

export const useLikes = () => useContext(LikesContext);

export const LikesProvider = ({ children }) => {
  const [likesCount, setLikesCount] = useState({});
  const [likedPosts, setLikedPosts] = useState({});
  const [commentCounts, setCommentCounts] = useState({});

  const updateLike = useCallback((postId, liked, count) => {
    setLikedPosts((prev) => ({ ...prev, [postId]: liked }));
    setLikesCount((prev) => ({ ...prev, [postId]: count }));
  }, []);

  const updateCommentCount = useCallback((postId, count) => {
    setCommentCounts((prev) => ({ ...prev, [postId]: count }));
  }, []);

  const contextValue = useMemo(() => ({
    likesCount,
    likedPosts,
    setLikesCount,
    setLikedPosts,
    updateLike,
    commentCounts,
    setCommentCounts,
    updateCommentCount
  }), [likesCount, likedPosts, updateLike, commentCounts, updateCommentCount]);

  return (
    <LikesContext.Provider value={contextValue}>
      {children}
    </LikesContext.Provider>
  );
};